import _typeof from "babel-runtime/helpers/typeof";
import _Object$values from "babel-runtime/core-js/object/values";
import _defineProperty from "babel-runtime/helpers/defineProperty";
import _extends from "babel-runtime/helpers/extends";
import builder from "./util";

export var emptyForm = {
  type: "individual",
  company: "",
  firstname: "",
  lastname: "",
  phone: "",
  email: "",
  store: "",
  accepted: false
};

var module = builder({
  getInitialState: function getInitialState() {
    return _extends({}, emptyForm);
  },
  actions: {
    reset: function reset() {
      return function () {
        return _extends({}, emptyForm);
      };
    },
    setFieldValue: function setFieldValue(state) {
      return function (_ref) {
        var field = _ref.field,
            value = _ref.value;
        return _extends({}, state, _defineProperty({}, field, value));
      };
    }
  }
});

module.isValid = function (form) {
  var accepted = form.accepted,
      company = form.company,
      store = form.store,
      email = form.email;

  var isValidFormat = !_Object$values(form).filter(function (value) {
    return (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" || typeof value === "array";
  }).length;
  return !!isValidFormat && !!accepted && (module.isIndividual(form) ? true : !!company) && !!email && !!store;
};
module.isIndividual = function (_ref2) {
  var type = _ref2.type;

  return type === "individual";
};

export default module;
//# sourceMappingURL=registration.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/stores/registration.js
// module id = 187
// module chunks = 0